import React, { useState } from 'react';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import NZCIListItem from '../../Base/NZCIListItem';
import FormattedDate from '../../../../../Components/FormattedDate';
import ElectronicPrescriptionDetailModal from '../Detail/ElectronicPrescriptionDetailModal';
import { NCZIElectronicPrescriptionMedicationItem } from '../../../Interfaces/ncziElectronicPrescriptionMedicationItem';

//@ts-ignore
import styles from './ElectronicPrescriptionMedicationItem.module.scss';

interface Props {
	item: NCZIElectronicPrescriptionMedicationItem;
	key: number;
}

const ElectronicPrescriptionMedicationItem: React.FC<Props> = props => {
	const { item } = props;

	return (
		<div className={styles.wrapper}>
			<div className={styles.border}>
				<div className={styles.content}>
					<div className={styles.header}>
						<div className={styles.openEntryName}>{item.barcode}</div>
					</div>

					<div className={styles.itemInfo}>
						<NZCIListItem title='nczi.createdAt' value={item.date} />
						<NZCIListItem
							title='nczi.electronicPrescription.detail.productCode'
							value={
								<>
									<strong>{item.quantity}x </strong>
									{item.product.code ? item.product.code + ': ' : ''}
									<strong>{item.product.name}</strong>{' '}
									{item.product.description && (
										<>({item.product.description})</>
									)}
								</>
							}
						/>
						{item.dosage && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.dosage.title'
								value={item.dosage}
							/>
						)}
						{item.diagnosis && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.diagnosisCode'
								value={
									item.diagnosis.abbr +
									': ' +
									item.diagnosis.reference?.displayName
								}
							/>
						)}
						{item.repeat.count && (
							<>
								<NZCIListItem
									title='nczi.electronicPrescription.detail.repeat.period'
									value={item.repeat.period}
								/>
								<NZCIListItem
									title='nczi.electronicPrescription.detail.repeat.count'
									value={item.repeat.count}
								/>
							</>
						)}
						{item.doctor.name && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.doctorCode'
								value={item.doctor.name}
								extra={item.doctor.code}
							/>
						)}
						{item.doctor.specialization && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.workplaceCode'
								value={item.doctor.workplace}
								extra={item.doctor.specialization}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ElectronicPrescriptionMedicationItem;
